export class ClockResult{
  public name: string;
  public lastname: string;
  public phone: string;
  public msg!: string;
}
